import { all, call, put, take } from 'redux-saga/effects'
import { TimeoutError } from 'services/api/errors'
import { getType } from 'typesafe-actions'

import { flashNoticeSaga } from '../components/FlashNotice/duck/operations'
import { serverFailure } from '../data/actions'
import { dataSaga } from '../data/operations'
import { accountPageSaga } from '../scenes/Account/duck/operations'
import { dashboardSaga } from '../scenes/Dashboard/duck/operations'
import { PayloadActionCreated } from './actions'

export default function* rootSaga() {
  while (true) {
    try {
      yield all([dashboardSaga(), flashNoticeSaga(), accountPageSaga(), dataSaga()])
    } catch (e) {
      // console.error('saga aborted due to:', e)
      // console.log('restarting the saga...')
    }
  }
}

export function* callApi<ReturnType, Arguments extends any[]>(
  apiMethod: (...args: Arguments) => Promise<ReturnType>,
  ...args: Arguments
): any {
  try {
    const apiResponse = yield call(apiMethod, ...args)
    return apiResponse
  } catch (error) {
    if (error instanceof TimeoutError) {
      // TODO: do something in this case.
    } else {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.error((error as Error).stack)
      }
      yield put(serverFailure())
      throw error
    }
  }
}

export function* waitFor<ActionCreator extends PayloadActionCreated>(
  actionCreator: ActionCreator,
  endWaitChecker: (payload: ReturnType<ActionCreator>['payload']) => boolean
) {
  while (true) {
    const action: ReturnType<ActionCreator> = yield take(getType(actionCreator as any))
    const endWait = endWaitChecker(action.payload)
    if (endWait) {
      return action.payload
    }
  }
}
